<template>
  <div class="home">
    <div class="page">
      <Header></Header>
      <div class="front-page">
        <DateRangeChooser
          :startDate="startDate"
          :endDate="endDate"
          @updateDate="updateDate"
        ></DateRangeChooser>
      </div>
      <ApolloQuery
        :query="require('../graphql/Newsletter.gql')"
        :variables="{ data }"
      >
        <template slot-scope="{ result: { loading, error, data } }">
          <!-- Loading -->
          <div v-if="loading" class="loading apollo">Loading...</div>

          <!-- Error -->
          <div v-else-if="error" class="error apollo">An error occured</div>

          <!-- Result -->
          <div v-else-if="data" class="result apollo">
            <div v-for="item in data.page.body" v-bind:key="item.id">
              <!-- <div v-if="item.field === 'countdown'">
                <Countdown :countdown-time="item.rawValue" />
              </div> -->
              <div class="front-page">
                <div v-if="item.field === 'campaign_section'">
                  <ContentPage :content="item.blocks"></ContentPage>
                </div>
                <div
                  v-if="
                    item.field === 'chart_id' &&
                      item.rawValue === 'weekly-milestones'
                  "
                >
                  <weekly-milestones
                    :start="startDate + 'T00:00:00+00:00'"
                    :end="endDate + 'T00:00:00+00:00'"
                  ></weekly-milestones>
                </div>
                <div
                  v-if="
                    item.field === 'chart_id' &&
                      item.rawValue === 'weekly-achieved-milestones'
                  "
                >
                  <weekly-achieved-milestones
                    :start="startDate + 'T00:00:00+00:00'"
                    :end="endDate + 'T00:00:00+00:00'"
                  ></weekly-achieved-milestones>
                </div>
              </div>
            </div></div></template
      ></ApolloQuery>
    </div>

    <footer>
      <div class="logo">
        <span class="stamp is-nope">Verdrusssache</span>
      </div>
    </footer>
  </div>
</template>

<script>
import Header from "../components/newsletter/Header";
import ContentPage from "../components/ContentPage";
import WeeklyMilestones from "../components/newsletter/WeeklyMilestones";
import WeeklyAchievedMilestones from "../components/newsletter/WeeklyAchievedMilestones";
import DateRangeChooser from "../components/newsletter/DateRangeChooser";
export default {
  name: "Newsletter",
  components: {
    WeeklyMilestones,
    Header,
    ContentPage,
    DateRangeChooser,
    WeeklyAchievedMilestones
  },
  metaInfo() {
    return {
      title: "OZG News",
      meta: [
        { name: 'description', property: 'og:description', content: 'Jede Woche werden Meilensteine im Rahmen des OZG erreicht und verfehlt. Eine Übersicht der letzen Monate.'},
        { property: 'twitter:title', content: "OZG News"},
        {name: 'image', property: 'og:image', content: "https://ozg.verdrusssache.de/peview-newsletter.png"},
        {name: 'twitter:description', content: 'Jede Woche werden Meilensteine im Rahmen des OZG erreicht und verfehlt. Eine Übersicht der letzen Monate.'},
        { property: 'twitter:card', content: 'summary_large_image'},
        {property: 'author', content: 'Lilith Wittmann'},
        {name: 'twitter:image', content: "https://ozg.verdrusssache.de/peview-newsletter.png"},
      ]
    }
  },
  data() {
    let firstDay = new Date();
    firstDay.setDate(0);
    firstDay.setDate(1);
    let lastDay = new Date();
    lastDay.setDate(0);
    return {
      startDate:firstDay.toISOString().split("T")[0],
      endDate: lastDay.toISOString().split("T")[0],
      data: null
    };
  },
  methods: {
    updateDate(newValue) {
      console.log(newValue);
      this.startDate = newValue.startDate;
      this.endDate = newValue.endDate;
    }
  }
};
</script>

<style scoped></style>
